import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "module-status-indicator" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "ARMED", -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "DISARMED", -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]

import { onMounted, ref, watch } from "vue";
import ScrewHead from "@src/components/ScrewHead.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleStatusIndicator',
  props: {
  isArmed: {
    type: Boolean,
    required: true,
  },
  isDisarmed: {
    type: Boolean,
    required: true,
  },
  strikeNumber: {
    type: Number,
    default: () => 0,
  },
},
  setup(__props) {

const props = __props;

const STRIKE_BLINK_INTERVALS: { [index: number]: number } = {
  1: 400,
  2: 200,
};



const isArmedLocal = ref(false);
let blinkTimerId: number;

watch(
  () => props.isArmed,
  (value: boolean) => {
    if (!value) {
      clearInterval(blinkTimerId);
    }
    isArmedLocal.value = value;
  },
);

watch(
  () => props.strikeNumber,
  (number: number) => {
    if (number > 0) {
      startBlinkInterval(STRIKE_BLINK_INTERVALS[number]);
    }
  },
);

function startBlinkInterval(interval: number): void {
  clearInterval(blinkTimerId);
  blinkTimerId = <number>(<unknown>setInterval(() => {
    if (props.isArmed) {
      isArmedLocal.value = !isArmedLocal.value;
    }
  }, interval));
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["led armed", { active: isArmedLocal.value }])
    }, _hoisted_3, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass(["led disarmed", { active: __props.isDisarmed }])
    }, _hoisted_5, 2 /* CLASS */)
  ]))
}
}

})